import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import IconPattern from '@mlb/react-patterns/components/Icon/icon.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';

const ICON_BOX_MARGIN_PERCENTAGE = 31;

const Icon = styled(IconPattern)`
    margin: auto auto auto ${({ $size }) => $size * ICON_BOX_MARGIN_PERCENTAGE / 100}px;
`;

const IconContainer = styled.div`
    display: flex;
    flex: 0 0 ${({ $size }) => $size}px;
    border-radius: 50%;
    height: ${({ $size }) => $size}px;
    width: ${({ $size }) => $size}px;
    background: ${({ backgroundColor }) => backgroundColor};
`;

const PlayIcon = (props) => {

    const {
        backgroundColor, color, width, className, 
    } = props;

    return (
        <IconContainer className={className} $size={width} backgroundColor={backgroundColor}>
            <Icon name="play" fill={color} $size={width} width={width / 2} />
        </IconContainer>
    );

};

PlayIcon.propTypes = {
    backgroundColor: PropTypes.string,
    className: PropTypes.string,
    color: PropTypes.string,
    width: PropTypes.number.isRequired,
};

PlayIcon.defaultProps = {
    backgroundColor: COLORS.mlbWhite,
    color: COLORS.mlbBlack,
};

export default PlayIcon;